// @flow
import React from "react";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import styles from "./ItemGlobalCard.scss";

type Props = {
  item: Object
};

const ItemGlobalCard = (props: Props) => {
  const item = props.item || "";
  return (
    <div className={styles.wrapper_card}>
      <div className={styles.ctr_card}>
        <div className={styles.topBox}>
          <span className={styles.netamountlabel}>
            {I18n.getText("sales.net-amount", {}, "Net Amount")}
            <p className={styles.netamount}>
              {I18n.formatCurrency(
                Helper.formatPrice(item.target_net_due, item.currency_code)
              )}
            </p>
          </span>

          <span
            className={`${styles.badge} ${
              styles[item.current_status_code || "other"]
            }`}
          >
            {item.current_status}
          </span>
        </div>
        <div className={styles.box}>
          <div className={styles.eachSpec}>
            <p className={styles.label}>
              {I18n.getText("sales.shipped-date", {}, "Shipped On")}
            </p>
            <p className={styles.value}>{item.shipped_date || "-"}</p>
          </div>
          <div className={styles.eachSpec}>
            <p className={styles.label}>
              {I18n.getText("statement-details.item-no", {}, "Item No")}
            </p>
            <p className={styles.value}>{item.item_nr || "-"}</p>
          </div>
          <div className={styles.eachSpec}>
            <p className={styles.label}>
              {I18n.getText("sales.invoice-nr", {}, "Invoice No")}
            </p>
            <a
              href={
                item.invoice_nr
                  ? `/${Helper.getLocale()}/statements?invoice_nr=${
                      item.invoice_nr
                    }`
                  : null
              }
              target="_blank"
            >
              <p className={styles.value}>{item.invoice_nr || "-"}</p>
            </a>
          </div>
          <div className={styles.eachSpec}>
            <p className={styles.label}>
              {I18n.getText("sales.credit-note-nr", {}, "Credit Note No")}
            </p>
            <p className={styles.value}>{item.creditnote_nr || "-"}</p>
          </div>
          <div className={styles.eachSpec}>
            <p className={styles.label}>
              {I18n.getText("statement-details.sku", {}, "SKU")}
            </p>
            <p className={styles.value}>{item.sku || "-"}</p>
          </div>
          <div className={styles.eachSpec}>
            <p className={styles.label}>
              {I18n.getText("statement-details.partner-sku", {}, "Partner SKU")}
            </p>
            <p className={styles.value}>{item.partner_sku || "-"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemGlobalCard;



// WEBPACK FOOTER //
// ./src/components/sales/salesDetails/ItemGlobalCard.js